// THE CALL'S SOUND at the shell root (components/CallAudio.js): one <audio>
// per remote member, beside the dock, so a live call keeps playing on every
// route — the tiles' own <audio> unmounted with /meet and a call went silent
// behind the dock (a Codex review of the call theater, 2026-10-18). Eager: the
// host mounts before the meet context is folded (components/eagerSlice.js).
import { getLivekitRoom } from './connectCall.js'
import { attachParticipantAudio } from './attachTracks.js'

// The host's element for one remote member: its audio track, attached here
// (connectCall's track events attach it too, functions/attachTracks.js).
export const meetCallAudioAttach = function meetCallAudioAttach(el, s) {
  const node = el && el.node
  const identity = s && s.identity
  if (!node || !identity) return false
  attachParticipantAudio(node, getLivekitRoom(), identity)
  return true
}

// The members the host plays: the remote camera entries of the call's list
// (never mine, never a screen-share entry — the same mic twice).
export const meetCallAudioMembers = function meetCallAudioMembers(root) {
  const r = root || (this && this.state && this.state.root) || {}
  const list = Array.isArray(r.livekitParticipants) ? r.livekitParticipants : []
  return list
    .filter((p) => p && !p.isLocal && !p.isScreen && p.identity)
    .map((p) => ({ key: 'a-' + String(p.identity), identity: String(p.identity) }))
}
